import request from '@/utils/request'

// 确认接单
export function confirmSubscribe(id, data) {
  return request({
    url: `/subscribe_orders/${id}/confirm`,
    method: 'post',
    data
  })
}

// 确认发货
export function subscribeOrderDeliver(id, data) {
  return request({
    url: `/subscribe_orders/${id}/deliver`,
    method: 'post',
    data
  })
}

// 确认送达
export function subscribeOrderDelivered(id, data) {
  return request({
    url: `/subscribe_orders/${id}/delivered`,
    method: 'post',
    data
  })
}

// 查询发货信息
export function findSubscribeOrderDeliver(id, params) {
  return request({
    url: `/subscribe_orders/${id}/deliver_info`,
    method: 'get',
    params: params
  })
}

// 修改发货信息
export function updateSubscribeOrderDeliver(id, data) {
  return request({
    url: `/subscribe_orders/${id}/update_deliver`,
    method: 'post',
    data
  })
}

export function findSubscribeOrderDelivered(id, params) {
  return request({
    url: `/subscribe_orders/${id}/delivered_info`,
    method: 'get',
    params: params
  })
}

// 修改送达信息
export function updateSubscribeOrderDelivered(id, data) {
  return request({
    url: `/subscribe_orders/${id}/update_delivered`,
    method: 'post',
    data
  })
}

// 订单取消
export function subscribeOrderCancel(id, data) {
  return request({
    url: `/subscribe_orders/${id}/cancel`,
    method: 'post',
    data
  })
}
